export default __webpack_public_path__ + "static/media/dfl-1-rMIN.1bcd9040.avif";